import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateEveryoneSocialSettingsV3 = OpalApi<
  'UpdateEveryoneSocialSettingsV3',
  200
>

export const updateEveryoneSocialSettings: UpdateEveryoneSocialSettingsV3 =
  async (args = {}) => {
    const id = args.params?.path.everyone_social_settings_id

    if (typeof id !== 'string') {
      throw new Error('Must supply a valid everyone_social_settings_id.')
    }

    const url = new URL(
      `/v3/everyone_social_settings/${id}`,
      window.location.origin
    )

    return HttpClient()
      .patch(url.toString(), args.requestBody)
      .then((res) => res.data)
  }
